<template>
  <div class="delivery-form">
    <div
      :class="[
        'delivery-form__delivery',
        { 'with-error': deliveryMethodError },
      ]"
    >
      <h2 class="title">Lieferoptionen</h2>
      <form>
        <div
          :class="[
            'radio-form-item',
            { active: deliveryMethod === TRANSPORTER },
          ]"
          @click="() => handleCheckboxChange(TRANSPORTER)"
        >
          <input :checked="deliveryMethod === TRANSPORTER" type="radio" />
          <NoDeliveryContent :order="order" @editData="editData" />
        </div>
        <div
          v-if="showFreeDelivery"
          :class="['radio-form-item', { active: deliveryMethod === TO_PICKUP }]"
          @click="() => handleCheckboxChange(TO_PICKUP)"
        >
          <input :checked="deliveryMethod === TO_PICKUP" type="radio" />
          <DeliveryContent :order="order" @editData="editData" />
        </div>
        <p v-if="deliveryMethodError" class="error">Bitte Option wählen.</p>
      </form>
    </div>
    <div :class="['delivery-form__tires', { 'with-error': winterTiresError }]">
      <h2 class="title">Winterreifen auf Stahlfelgen</h2>
      <p style="margin-bottom:20px;font-size: 14px">
        Wir bieten Ihnen <b>zwei praktische Optionen</b>, um Ihr Wunschfahrzeug
        optimal für die Wintersaison zu rüsten. Fall Sie ein Angebot für
        passende Winterreifen auf Stahlfelgen erhalten möchten, wird unser
        PKW.de-Team Sie kontaktieren, um mit Ihnen
        <b>gemeinsam das optimale Angebot</b> für Ihr Auto zu erstellen.
      </p>
      <form>
        <div
          :class="[
            'radio-form-item',
            { active: winterTiresOption === 'economy' },
          ]"
          @click="() => handleTiresChange('economy')"
        >
          <input :checked="winterTiresOption === 'economy'" type="radio" />
          <div
            class="radio-form-item__top-content"
            style="display:flex;align-items: center;"
          >
            <img
              src="../assets/images/tire-winter-icon.png"
              alt="Winter tire"
              style="margin-left:20px;width:60px;height:50px;"
            />
            <div>
              <h4 style="font-size:14px">
                <b>Economy-Winterreifen</b><br />
                <p>
                  Sicherheit bei Schnee und Glätte - zum optimalen
                  Preis-Leistungsverhältnis
                </p>
              </h4>
            </div>
          </div>
        </div>

        <div
          :class="[
            'radio-form-item',
            { active: winterTiresOption === 'premium' },
          ]"
          @click="() => handleTiresChange('premium')"
        >
          <input :checked="winterTiresOption === 'premium'" type="radio" />
          <div
            class="radio-form-item__top-content"
            style="display:flex;align-items: center;"
          >
            <img
              src="../assets/images/tire-winter-icon.png"
              alt="Winter tire"
              style="margin-left:20px;width:60px;height:50px;"
            />
            <div>
              <h4 style="font-size:14px">
                <b>
                  <span class="fa-stack fa-sm" style="font-size: 12px;">
                    <i
                      class="fa fa-circle fa-stack-2x"
                      style="color:#006EBD"
                    ></i>
                    <i
                      class="fa fa-star fa-stack-1x"
                      style="color: #ffffff;font-size: 9px;"
                    ></i>
                  </span>
                  Premium-Winterreifen
                </b>
                <br />
                <p>
                  Markenqualität von Premiumherstellern - getestete Sicherheit
                  der Spitzenklasse
                </p>
              </h4>
            </div>
          </div>
          <div class="red-ribbon"><span>Empfehlung</span></div>
        </div>

        <div
          :class="['radio-form-item', { active: winterTiresOption === 'none' }]"
          @click="() => handleTiresChange('none')"
        >
          <input :checked="winterTiresOption === 'none'" type="radio" />
          <div
            class="radio-form-item__top-content"
            style="display:flex;align-items: center;"
          >
            <img
              src="../assets/images/tire-icon.png"
              alt="Winter tire"
              style="margin-left:20px;width:60px;height:50px;"
            />
            <div>
              <h4 style="font-size:14px">
                <b>Keine Winterräder</b><br />
                <p>
                  Ich möchte keine Winterräder. Witterungsbedingte Verzögerungen
                  bei der Lieferung meines Wunschfahrzeugs nehme ich in Kauf.
                </p>
              </h4>
            </div>
          </div>
        </div>
        <p v-if="winterTiresError" class="error">Bitte Option wählen.</p>
      </form>
      <div class="btns">
        <button class="btn btn-red" type="button" @click="openModal">
          Fragen zur Lieferung?
        </button>
        <button class="btn" type="button" @click="updateOrderData">
          {{ editMode ? "Änderungen übernehmen" : "Nächster Schritt" }}
        </button>
      </div>
      <ServiceInfoModal
        :is-open="showModal"
        @close="closeModal"
        :order="order"
      />
    </div>
  </div>
</template>

<script>
import DeliveryContent from "@/components/DeliveryContent";
import NoDeliveryContent from "@/components/NoDeliveryContent";
import ServiceInfoModal from "@/components/modals/ServiceInfoModal";

export default {
  components: {
    DeliveryContent,
    NoDeliveryContent,
    ServiceInfoModal,
  },
  props: ["order", "editMode"],
  data() {
    return {
      deliveryMethod: this.order.delivery_method || "",
      deliveryMethodError: false,
      // winterTires: this.order.winter_tires || '',
      winterTiresOption: this.order.winter_tires_option || "",
      winterTiresError: false,
      noTiresAgreement: false,
      noTiresAgreementError: false,
      showModal: false,
      TRANSPORTER: "transporter",
      TO_PICKUP: "standard",
    };
  },
  computed: {
    showNoTires() {
      return this.deliveryMethod === "standard" && this.winterTires === false;
    },
    showFreeDelivery() {
      return this.order.car_info.online_offer_services.free_delivery;
    },
  },
  watch: {
    deliveryMethod(val) {
      if (val && this.deliveryMethodError) {
        this.deliveryMethodError = false;
      }
    },
    winterTires(val) {
      if (val && this.winterTiresError) {
        this.winterTiresError = false;
      }
    },
  },
  methods: {
    updateOrderData(e) {
      e.preventDefault();
      const isValid = this.validateForm();
      if (isValid) {
        this.sending = true;
        const params = {
          // {"delivery_service": delivery_service_value}
          // delivery_service_value: standard|transporter|to_pickup
          delivery_service: this.deliveryMethod,
          // winter_tires: this.winterTires,
          winter_tires_option: this.winterTiresOption,
        };
        this.$emit("updateOrderStep", this.order.token, params);
      }
    },
    validateForm() {
      let noError = true;
      if (this.deliveryMethod === "") {
        this.deliveryMethodError = true;
        noError = false;
      } else {
        this.deliveryMethodError = false;
      }
      if (this.winterTiresOption === "") {
        this.winterTiresError = true;
        noError = false;
      } else {
        this.winterTiresError = false;
      }
      if (this.showNoTires && this.noTiresAgreement === false) {
        this.noTiresAgreementError = true;
        noError = false;
      } else {
        this.noTiresAgreementError = false;
      }
      if (noError) {
        this.deliveryMethodError = false;
        this.winterTiresError = false;
        this.noTiresAgreementError = false;
      }
      return noError;
    },
    handleCheckboxChange(value) {
      this.deliveryMethod = value;
    },
    handleTiresChange(value) {
      this.winterTiresOption = value;
      this.noTiresAgreement = false;
    },
    editData() {
      this.$emit("editData");
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss">
.delivery-form {
  .radio-form-item__top-content {
    flex-grow: 1;
  }
  padding: 30px 0.625rem;
  .delivery-form__tires {
    margin-top: 20px;
    .radio-form-item__top-content {
      > div {
        flex-direction: column;
        @include breakpoint(desktop) {
          flex-direction: row;
          .radio-form-item__bell {
            width: 250px;
          }
        }
        h4 {
          font-weight: 400;
        }
        &.no-tires {
          flex-direction: column;
          &.with-error {
            .error {
              margin-left: 0;
              padding: 5px 0;
              font-size: 12px;
              line-height: 12px;
              color: $red;
            }
            input[type="checkbox"] + label:before {
              border-color: $red;
            }
          }
          .financed-plan-form__checkbox {
            margin: 30px 0;
            .custom-checkbox {
              input[type="checkbox"]:checked + label:after {
                top: 0;
              }
            }
            > div {
              display: flex;
              align-items: center;
              color: $red;
              > p {
                font-size: 14px;
                line-height: 22px;
                margin-left: 30px;
              }
            }
          }
        }
      }
    }
  }

  @include breakpoint(desktop) {
    padding: 30px 0;
  }

  .video {
    margin-top: 30px;
    max-width: 500px;
    h3 {
      margin-bottom: 20px;
      line-height: 30px;
    }
  }

  .delivery-form__note {
    display: inline-block;
    font-size: 14px;
    line-height: 22px;
    padding-left: 30px;
  }

  .btns {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .btn-red {
      margin-right: 10px;
      font-weight: 400;
      border: 1px solid $red;
      background-color: transparent;
      color: $red;
    }
  }
  .radio-form-item {
    margin-bottom: 10px;
    display: flex;
    align-items: start;
    input[type="radio"] {
      position: relative;
      top: 6px;
    }
    &__main-content {
      margin: 20px 0 30px;
      button {
        color: $red;
      }
    }
    &__bell {
      margin: 10px 0 0 30px;
      font-size: 14px;
      font-weight: 700;
      color: $red;
      i {
        margin-right: 5px;
      }
    }
  }
  .check-list {
    margin-top: 20px;
  }
  .btn {
    margin-top: 10px;
  }
  .with-error {
    .radio-form-item {
      border-color: $red;
    }
    .title {
      color: $red;
    }
    .error {
      font-size: 12px;
      line-height: 24px;
      color: $red;
    }
  }
  .check-list button {
    padding: 0;
  }
  @include breakpoint(medium) {
    .btns {
      flex-direction: row;
    }
  }
  @include breakpoint(desktop) {
    .radio-form-item {
      &__main-content {
        display: flex;
        padding-left: 30px;
        > * {
          flex: 1;
        }
      }
    }
  }
}
</style>
<style scoped>
.radio-form-item {
  margin-bottom: 20px;
}
</style>
